import type { OgCityKey } from "@/lib/ogImages";

export const COLORADO_SPRINGS_PROFILE: {
  city: string;
  citySlug: OgCityKey;
  cityGeo: { lat: number; lng: number };
  zips: string[];
  neighborhoods: string[];
  nearbyCities: string[];
} = {
  city: "Colorado Springs",
  citySlug: "colorado-springs",
  cityGeo: { lat: 38.8339, lng: -104.8214 },
  zips: [
    "80903", "80904", "80906", "80907", "80908", "80909",
    "80915", "80916", "80917", "80918", "80919", "80920",
    "80921", "80922", "80923", "80924",
  ],
  neighborhoods: [
    "Briargate", "Powers Corridor", "Northgate", "Black Forest",
    "Old Colorado City", "Falcon", "Monument", "Security-Widefield",
  ],
  nearbyCities: ["Monument", "Fountain", "Falcon", "Manitou Springs"],
};
